<template>
    <ul>
        <li v-for="item in list" :key="item.title" class="menus-list">
            <a
                :href="item.link"
                :class="{ active: hoverTitle === item.title }"
                :target="item.target"
                @click.prevent="handleLinkClick(item, 1, item.target)"
            >
                <span class="title">{{ item.title }}</span>
                <span class="click" :class="handleIcon(item, 1)"></span>
            </a>
            <ul class="menus-children" :class="{ active: hoverTitle === item.title }">
                <li v-for="itemChildren in item.children" :key="itemChildren.title">
                    <a
                        :href="itemChildren.link"
                        :class="{
                            active: hoverChildTitle === itemChildren.title
                        }"
                        :target="itemChildren.target"
                        @click.prevent="handleLinkClick(itemChildren, 2, itemChildren.target)"
                    >
                        <span class="item-children-title">{{ itemChildren.title }}</span>
                        <!-- <span class="click" :class="handleIcon(itemChildren, 2)"></span> -->
                    </a>
                    <ul
                        class="menus-children-children"
                        :class="{
                            active: hoverChildTitle === itemChildren.title
                        }"
                    >
                        <li v-for="itemChildrenChild in itemChildren.children" :key="itemChildrenChild.title">
                            <a
                                :href="itemChildrenChild.link"
                                :target="itemChildrenChild.target"
                                @click.prevent="handleLinkClick(itemChildrenChild, 3, itemChildrenChild.target)"
                            >
                                <span>{{ itemChildrenChild.title }}</span>
                                <!-- <span class="click" :class="handleIcon(itemChildrenChild, 3)"></span> -->
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </li>
    </ul>
</template>

<script>
export default {
    components: {},
    props: {
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            hoverTitle: '',
            hoverChildTitle: ''
        }
    },
    methods: {
        // 点击了链接
        handleLinkClick(item, type, target) {
            if (item.link) {
                window.open(item.link, target)
            } else {
                switch (type) {
                    case 1:
                        this.hoverTitle = this.hoverTitle === item.title ? '' : item.title
                        this.hoverChildTitle = ''
                        break
                    case 2:
                        this.hoverChildTitle = this.hoverChildTitle === item.title ? '' : item.title
                    default:
                        break
                }
            }
        },
        // 图标处理
        handleIcon(item, type) {
            switch (type) {
                case 1:
                    return this.hoverTitle === item.title ? 'minus' : !item.link && item.children.length > 0 ? 'plus' : 'triangle'
                case 2:
                    return this.hoverChildTitle === item.title ? 'minus' : !item.link && item.children.length > 0 ? 'plus' : 'triangle'
                default:
                    return !item.link && item.children.length > 0 ? 'plus' : 'triangle'
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.menus-list {
    line-height: 100px;
    border-top: 1px solid #f5f5f5;
    font-size: 35px;
    &:last-of-type {
        border-bottom: 1px solid #f5f5f5;
    }
    a {
        color: rgba(10, 15, 22, 0.6);
        display: flex;
        position: relative;
        justify-content: space-between;
        align-items: center;
        font-size: 28px;
        .title {
            color: #0a0f16;
            font-size: 29px;
            font-weight: 600;
        }
        .click {
            display: block;
            width: 36px;
            height: 36px;
            &.minus {
                height: 4px;
                background-image: url('~@/assets/images/header/minus.png');
                background-position: center center;
                background-repeat: no-repeat;
                background-size: cover;
            }
            &.plus {
                background-image: url('~@/assets/images/header/plus.png');
                background-position: center center;
                background-repeat: no-repeat;
                background-size: cover;
            }
            &.triangle {
                background-image: url('~@/assets/images/header/triangle.png');
                background-position: center center;
                background-repeat: no-repeat;
                background-size: cover;
            }
        }
        &.active {
            color: #ca363a;
        }
    }
    .menus-children {
        overflow: hidden;
        max-height: 0;
        transition: max-height 0.3s;
        li {
            border-top: 1px solid #f5f5f5;
        }
        &.active {
            max-height: 1500px;
            transition: max-height 0.5s;
        }
        .item-children-title {
            color: #0a0f16;
            font-size: 28px;
            font-weight: 400;
        }
        .menus-children-children {
            overflow: hidden;
            max-height: 0;
            transition: max-height 0.3s;
            &.active {
                max-height: 1500px;
                transition: max-height 0.5s;
            }
            a {
                margin-left: 140px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/header/components/submenu.vue